import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class MsService extends ApiService {
  constructor(router: Router, httpClient: HttpClient) {
    super(router, httpClient);
    this.setBaseUrl(environment.gatewayUrl);
  }
}
